import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField, SelectField, MenuItem } from 'material-ui';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import '../../../grid.css';
import Btn from '../../../components/Btn';

class TaxInputs extends Component {
    toggleTaxInputVisiblity() {
        const { setTaxInputIsVisible, isVisible } = this.props;
        setTaxInputIsVisible(!isVisible);
    }

    handleTaxRateChange(value) {
        const { setTaxRate } = this.props;
        setTaxRate(parseFloat(value, 10));
    }

    handleInstallYearChange(value) {
        const { setInstallYear } = this.props;
        setInstallYear(Number(value));
    }

    toggleTaxEntity() {
        const { setTaxEntity, taxEntity } = this.props;
        setTaxEntity(!taxEntity);
    }
    toggleResi() {
        const {
            setResiToggle, resiToggle, setShowOBS, setShowPPA, setShowCAP, setLoanProvider,
        } = this.props;
        setResiToggle(!resiToggle);
        setShowOBS(false);
        setShowPPA(false);
        setShowCAP(false);
        if (resiToggle) {
            setLoanProvider(2);
        }
        if (!resiToggle) {
            setLoanProvider(1);
        }
    }

    render() {
        const {
            isLocked, isVisible, taxRate, installYear, taxEntity, resiToggle,
        } = this.props;

        return (
            <div>
                <Btn label="Tax" onClick={(e, value) => this.toggleTaxInputVisiblity(value)} />
                {isVisible && (
                    <div className="row">
                        <FormControlLabel
                            className="col span-1-of-4"
                            control={
                                <Checkbox
                                    onChange={(e, value) => this.toggleResi(value)}
                                    checked={resiToggle}
                                />
                            }
                            label="Residential"
                        />
                        <FormControlLabel
                            className="col span-1-of-4"
                            control={
                                <Checkbox
                                    disabled
                                    onChange={(e, value) => this.toggleTaxEntity(value)}
                                    checked={taxEntity}
                                />
                            }
                            label="Tax Paying Entity"
                        />
                        <div className="col span-1-of-5">
                            <TextField
                                hintText="21"
                                defaultValue={taxRate}
                                floatingLabelText="Company Tax Rate"
                                onChange={(e, value) => this.handleTaxRateChange(value)}
                                disabled={isLocked}
                            />
                        </div>
                        <div className="col span-1-of-5">
                            <SelectField
                                value={installYear}
                                onChange={(event, index, value) =>
                                    this.handleInstallYearChange(value)
                                }
                                floatingLabelText="Installation Year"
                                disabled={isLocked}
                            >
                                <MenuItem value={2019} primaryText="2019" />
                                <MenuItem value={2020} primaryText="2020" />
                                <MenuItem value={2021} primaryText="2021" />
                                <MenuItem value={2022} primaryText="2022" />
                            </SelectField>
                        </div>
                    </div>

                )}
            </div>
        );
    }
}

TaxInputs.propTypes = {
    installYear: PropTypes.number.isRequired,
    isLocked: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    setInstallYear: PropTypes.func.isRequired,
    setTaxRate: PropTypes.func.isRequired,
    setTaxInputIsVisible: PropTypes.func.isRequired,
    taxRate: PropTypes.number.isRequired,
    taxEntity: PropTypes.bool.isRequired,
    resiToggle: PropTypes.bool.isRequired,
    setTaxEntity: PropTypes.func.isRequired,
    setResiToggle: PropTypes.func.isRequired,
    setShowOBS: PropTypes.func.isRequired,
    setShowPPA: PropTypes.func.isRequired,
    setShowCAP: PropTypes.func.isRequired,
    setLoanProvider: PropTypes.func.isRequired,
};

export default TaxInputs;



// WEBPACK FOOTER //
// ./src/containers/Inputs/TaxInputs/TaxInputs.js